<div class="modal-container">
    <div class="content-container">
        <div class="selection-container">
            <h2 i18n>Select your assistance package</h2>
            <div class="options-container">
                <div class="option">
                    <div class="top-container">
                        <div class="name-container">
                            <p i18n >Bronz</p>
                        </div>
                        <div class="img-container">
                            <img src="./assets/image/assistance-packages/Bronze.png" alt="">
                        </div>
                    </div>
                    <div class="bottom-container">
                        <div class="description-container">
                            <li i18n>1-hour conference meeting with our experts, where additional participants can join</li>
                            <li i18n>Assistance in creating a profile, uploading a GEDCOM file, and a quick overview of the system</li>
                        </div>
                        <div class="select-container">
                            <p i18n ><app-currency-converter [data]="{price:10, country: null}"></app-currency-converter></p>
                            <button i18n  *ngIf="selectedAP.value.attributeId != '12'" (click)="changeId('12')">Select</button>
                            <button i18n  class="selected-button" *ngIf="selectedAP.value.attributeId == '12'" >Selected</button>
                        </div>
                    </div>
                </div>
                <div class="option">
                    <div class="top-container">
                        <div class="name-container">
                            <p i18n >Silver</p>
                        </div>
                        <div class="img-container">
                            <img src="./assets/image/assistance-packages/Silver.png" alt="">
                        </div>
                    </div>
                    <div class="bottom-container">
                        <div class="description-container">
                            <li i18n>30-minute private conference meeting with our experts</li>
                            <li i18n>Assistance in creating a profile, uploading a GEDCOM file, and a quick overview of the system</li>
                            <li i18n>1 design proposal according to your preferences</li>
                        </div>
                        <div class="select-container">
                            <p><app-currency-converter [data]="{price:25, country: null}"></app-currency-converter></p>
                            <button i18n  *ngIf="selectedAP.value.attributeId != '13'" (click)="changeId('13')">Select</button>
                            <button i18n  class="selected-button" *ngIf="selectedAP.value.attributeId == '13'" >Selected</button>
                        </div>
                    </div>
                </div>
                <div class="option">
                    <div class="top-container">
                        <div class="name-container">
                            <p i18n >Gold</p>
                        </div>
                        <div class="img-container">
                            <img src="./assets/image/assistance-packages/Gold.png" alt="">
                        </div>
                    </div>
                    <div class="bottom-container">
                        <div class="description-container">
                            <li i18n>30-minute private conference meeting with our experts</li>
                            <li i18n>Assistance in creating a profile, uploading a GEDCOM file, and a quick overview of the system</li>
                            <li i18n>3 design proposals according to your preferences</li>
                            <li i18n>Free express delivery</li>
                        </div>
                        <div class="select-container">
                            <p><app-currency-converter [data]="{price:50, country: null}"></app-currency-converter></p>
                            <button i18n  *ngIf="selectedAP.value.attributeId != '14'" (click)="changeId('14')">Select</button>
                            <button i18n  class="selected-button" *ngIf="selectedAP.value.attributeId == '14'" >Selected</button>
                        </div>
                    </div>
                </div>
                <div class="option">
                    <div class="top-container">
                        <div class="name-container">
                            <p i18n >Platinum</p>
                        </div>
                        <div class="img-container">
                            <img src="./assets/image/assistance-packages/Platinum.png" alt="">
                        </div>
                    </div>
                    <div class="bottom-container">
                        <div class="description-container">
                            <li i18n>1-hour private conference meeting with one of our experts</li>
                            <li i18n>Assistance in creating a profile, uploading a GEDCOM file, and a quick overview of the system</li>
                            <li i18n>5 design proposals according to your preferences</li>
                            <li i18n>The opportunity to design a custom high-resolution background for your family tree. We will assist you in creating a high-resolution background based on your materials and preferences</li>
                            <li i18n>Free express delivery</li>
                            <li i18n>20% discount on your next order</li>
                        </div>
                        <div class="select-container">
                            <p><app-currency-converter [data]="{price:100, country: null}"></app-currency-converter></p>
                            <button i18n *ngIf="selectedAP.value.attributeId != '15'" (click)="changeId('15')" >Select</button>
                            <button i18n class="selected-button" *ngIf="selectedAP.value.attributeId == '15'" >Selected</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="action-container">
            <div class="attribute-container">
                <h2 i18n >Assistance Package</h2>
                <div class="attribute-field">  
                    <p i18n class="attribute-name">Tier:   </p> <p i18n class="attribute-value">{{selectedAP.value.tier || '-'}}</p>
                    <p i18n class="attribute-name">Price:   </p> <p i18n class="attribute-value"><app-currency-converter [data]="{price:selectedAP.value.price, country: null}"></app-currency-converter></p>
                </div>
            </div>
            <div class="button-container">
                <button i18n (click)="next()">Next</button>
            </div>
        </div>
    </div>
</div>